/** imported components

  * BreadcrumbsItem for ===> dynamic breadcrumb component of react.
  * $ from jquery ===> component from jquery to use jquery for the page
  * Helmet ===> for add specific title & CSS for the page.
  * AssignSectionPopup for ===> component cakll for assign user.
  * serviceProvider for ===> working with api
  * useState, useEffect ===> React hooks (useState is a way to get/set value)
  *  _ from 'lodash ===> javascript library

**/


import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import $ from "jquery";
import { Modal } from "@material-ui/core";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
import { Link, Redirect } from "react-router-dom";
import { AdminWalkthroughController } from '../admin-walkthrough/admin-walkthrough-ctrl'
import { AssignSectionPopup } from "./assessment-assign-popup";
import { array } from "prop-types";
import _ from 'lodash';

//defining svg image
const SubmitSvg = () => <svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M29.8002 5.65428L24.3457 0.199752C24.2179 0.0719106 24.0448 0 23.8636 0H2.7273C1.22382 0 0 1.22312 0 2.7273V27.2728C0 28.7769 1.22382 30.0001 2.7273 30.0001H27.2728C28.7762 30.0001 30.0001 28.7769 30.0001 27.2728V6.13637C30 5.95528 29.9281 5.78212 29.8002 5.65428ZM6.81821 1.36362H21.8182V9.54544C21.8182 10.2971 21.207 10.9091 20.4546 10.9091H8.18182C7.42942 10.9091 6.81821 10.2971 6.81821 9.54544V1.36362ZM24.5455 28.6364H5.45453V16.3636H24.5455V28.6364ZM28.6364 27.2728C28.6364 28.0245 28.0251 28.6364 27.2728 28.6364H25.9092V15.6818C25.9092 15.3049 25.6042 15 25.2273 15H4.77275C4.39588 15 4.09091 15.3049 4.09091 15.6818V28.6364H2.7273C1.97489 28.6364 1.36368 28.0245 1.36368 27.2728V2.7273C1.36368 1.97559 1.97495 1.36368 2.7273 1.36368H5.45459V9.5455C5.45453 11.0496 6.67835 12.2727 8.18182 12.2727H20.4546C21.958 12.2727 23.1819 11.0496 23.1819 9.54544V1.36362H23.5814L28.6364 6.4187V27.2728Z" fill="#178ACB" />
  <path d="M17.0456 9.54575H19.7729C20.1498 9.54575 20.4547 9.24078 20.4547 8.86391V3.40938C20.4547 3.0325 20.1498 2.72754 19.7729 2.72754H17.0456C16.6687 2.72754 16.3638 3.0325 16.3638 3.40938V8.86391C16.3638 9.24078 16.6687 9.54575 17.0456 9.54575ZM17.7274 4.09122H19.091V8.18213H17.7274V4.09122Z" fill="#178ACB" />
  <circle cx="31" cy="8" r="7" fill="#178ACB" />
  <rect x="32" y="9" width="2" height="6" rx="1" transform="rotate(-180 32 9)" fill="white" />
  <rect x="32" y="12.333" width="2" height="2" rx="1" transform="rotate(-180 32 12.333)" fill="white" />
</svg>

//AssessmentPlantView starts
export const AssessmentPlantView = (props) => {
  //Defining variables here
  const [isAssignSectionPopup, setIsAssignSectionPopup] = useState(false);
  const [isUpgradePopup, setIsUpgradePopup] = useState(false);
  const [isProductionPopup, setIsProductionPopup] = useState(false);
  const [cate, setCate] = useState();
  const [catename, setCateName] = useState();
  const [tmpAssignUser, setTmpAssignUser] = useState("");
  const [assignedUsers, setAssignedUsers] = useState({});
  const [sectionLockedHover, setSectionLockedHover] = useState(false);
  const [isFinalSubmit, setIsFinalSubmit] = useState(false);
  const [isSubmitPop, setIsSubmitPop] = useState(false);
  const [isPlanSubmit, setIsPlanSubmit] = useState(true);
  const [sliderActive, setSliderActive] = useState(0);
  const [distext, setDistext] = useState("Submit your input");
  const sectionDataItems = props.sectionData;
  
  const isusers = JSON.parse(localStorage.getItem("group_id"));
  const sectionDataItem = props.sectionData[0];
  const block = sectionDataItem.block;
  
  // console.log(sectionDataItems);
  const catData = sectionDataItem?.category;
  

  const inviteteam = sectionDataItem?.inviteteam;
  const isAssessmenttour = sectionDataItem.isAssessmenttour;

  const totalCat = catData.length;
  const slug = sectionDataItem.plantslug;

  useEffect(() => {
    let tmpObj = {};
    for (let i = 0; i < inviteteam.length; i++) {
      let name = "username" + inviteteam[i].invited_category;
      let val;
      let valname = inviteteam[i].full_name;
      if (valname == null || valname == "") {
        val = inviteteam[i].email;
      } else {
        val = inviteteam[i].full_name;
      }

      tmpObj = { ...tmpObj, [name]: val };
    }

    setAssignedUsers(tmpObj);
    if(sectionDataItem.is_datasubmitted != 0){
		setIsFinalSubmit(true);
    	//setIsSubmitPop(!isSubmitPop);
    	setIsPlanSubmit(false);	
		
	}
  }, []);
  

  // Function for final submit assessment
  const handleFinalSubmit = () => {
    setIsFinalSubmit(!isFinalSubmit);
    setIsSubmitPop(!isSubmitPop);
    setIsPlanSubmit(!isPlanSubmit);
	serviceProvider
		.post(
		"/assessmentmaturity?type=savechapter",
        JSON.stringify({ user_id:sectionDataItem?.uid, plant_id:sectionDataItem?.plant_id, section_id:0 }),
		true
      )
      .then((response) => {
		
      });
  }
  //Function to handle modal
  
  //Function for handle slide

  const otherScreen = () => {
    let unlockSection = document.querySelector('.unlockbtn');

  }
  //variable declaration for walkthrough
 
  //function to handle walkthrough and class addition
  const handleGetValue = (e = null) => {

    setSliderActive(e);
    let objDiv = document.querySelector('.training-content');
    let headerLink = document.querySelector('.header-page-link-ul');
    let headerProgress = document.querySelector('.header-right-frame');
    let projectNamebox = document.querySelector('.text-box')
    let projectName = document.querySelector('.text-left p')
    let icon = document.querySelector('.text-left img')
    let sideArrow = document.querySelector('.angle-box')
    let unlockSection = document.querySelector('.unlockbtn');
    let blur = document.querySelector('.admin-walkthrough')
    let progressBar = document.querySelector('.header-right-frame')

    if (e === 0) {
      blur.classList.add('blur-effect');
    } else {
      blur.classList.remove('blur-effect');
    }
    if (e === 1) {
      headerLink.classList.add('z-index9999');
      progressBar.classList.add('z-index9999');
    } else {
      progressBar.classList.remove('z-index9999');
      headerLink.classList.remove('z-index9999');
    }
    if (e === 2) {
      projectName.classList.add('z-index9999');
      icon.classList.add('z-index9999');
      projectNamebox.classList.add('z-index999');
    } else {
      projectName.classList.remove('z-index9999');
      icon.classList.remove('z-index9999');
      projectNamebox.classList.remove('z-index999');
    }
    if (e === 3) {
      sideArrow.classList.add('z-index9999');
    } else {
      sideArrow.classList.remove('z-index9999');
    }
    if (e === 4) {
      objDiv.scrollTop = objDiv.scrollHeight;
    } else {
      objDiv.scrollTop = 0;
    }
    if (e === 4 && sectionDataItem.noline == '') {
      unlockSection.classList.add('z-index9999');
    } else {
      if (unlockSection) { //added if to check class exists
        unlockSection.classList.remove('z-index9999');
      }
    }

  }
  //Function call for upgrade popup
  const HandleUpdgradePopup = () => {
    setIsUpgradePopup(!isUpgradePopup);
  };
  //Function for assign popup
  const handleAssignPoup = (e) => {
    var cat = $(e.target).attr("data-id");
    var catname = $(e.target).attr("data-name");
    console.log(catname);
    setCate(cat);
    setCateName(catname);
    setIsAssignSectionPopup(true);
    e.preventDefault();
  };

  const inActiveSectionClick = (e) => {
    let unlockSection = document.querySelector('.unlockbtn');
    if (!e.target.className.includes('assignee-link-unlock')) {
      setIsProductionPopup(true);
      unlockSection.classList.remove('z-index9999');
    }
  }
//Function for lock section
  const setSectionLocked = async (e, sectionId) => {
    e.preventDefault();
	
    if (typeof e.target.className.includes !== 'undefined' && !e.target.className.includes('assignee-link-unlock')) {
      try {
        await serviceProvider.post('/sectionlock', { uid: sectionDataItem?.uid, section_id: sectionId, type: 1, status: 1, plant_id: sectionDataItem?.plant_id })
      }
      catch (error) {
        console.log(error)
      }
      props.history.push(`/assessment/chapter/${slug}/${sectionId}`)
    }else{
		props.history.push(`/assessment/chapter/${slug}/${sectionId}`)
		}
	
  }

  const chapterDataItemSections = catData.map((chapter, index) => {
    const count = index + 1;
    // chapter.cardclass="active";
    return (
      //card wrapper for assessment
      <a
        key={chapter.id}
        data-index={index}
        href={
          chapter.cardclass == "active" && !chapter?.locked_user
            ? `/assessment/chapter/${slug}/${chapter.id}`
            : "#"
        }
        className={`all-sellection-card ${chapter.cardclass} `}
        onClick={(e) =>
          chapter.cardclass1 == "withuser" && chapter.cardclass == "inactive" && index == 8 && (group_id == 11 || group_id == 2)
            ? inActiveSectionClick(e)
            : chapter.cardclass == "active" && !chapter?.locked_user
              ? setSectionLocked(e, chapter.id) : '#'
          // : HandleUpdgradePopup()
        }
      >
        {/* Left box of the card which is containing image */}
        <div className="left-img-box">
          <img
            src={`https://apishowcasen.smarterchains.com/${chapter.category_img}`}
            alt={chapter.category_name}
          />
        </div>
        {index == 8 && sectionDataItem.noline == '' && (isusers == 11 || isusers == 2 || sectionDataItem.open_line == 1) &&
          <div className='unlockbtn' onClick={() => { otherScreen(); setIsProductionPopup(true) }}>Unlock this section</div>
        }
        {/* text-box has text ,l assigne/unassigned user */}
        <div className="text-box">
          <div className="text-left">
            <h2 className="h1">
              <span>{chapter.category_name}</span>
              <img src={ require("../../assets/img/all-section/card-i-icon.svg").default } alt="i"/>
            </h2>
            <p className="responsible-text">
              <span className="res-text">Responsible:</span>
              {!assignedUsers[`username${chapter.id}`] ? (
                <span className={`res-link assignee-link-unlock ${(isusers == 11 || isusers == 2) ? '' : chapter.cardclass} `}
                  data-id={chapter.id}
                  data-name={chapter.category_name}
                  onClick={(e) => {
                    if (isusers == 11 || isusers == 2) {
                      handleAssignPoup(e);
                      setTmpAssignUser(`username${chapter.id}`);
                    }
                  }}
                >
                  Unassigned+
                </span>
                ) : (
                <>
                  <span data-id={chapter.id} className="res-name">
                    {assignedUsers[`username${chapter.id}`]}
                  </span>

                </>
              )}
              {sectionDataItem.locked_sections_array.includes(chapter.id) ?  
                (
                  <div className="submit-img-text">
                    <img src={require("../../assets/img/assessment-right-section/check.svg").default} alt="Green Check" />
                    <span>Data Submitted</span>
                  </div>
                ) : (
                  <>

                  </>
                )}
            </p>
          </div>
          {/* Locked Section start*/}
          {chapter?.section_locked &&
            <div className="assigned-rgt-sub-mid" onMouseEnter={() => setSectionLockedHover(true)} onMouseLeave={() => setSectionLockedHover(false)}>
              <button className="lock-btn">
                <img alt="true" src={require("../../assets/img/assigned/lock.svg").default} />
                <span>Section Locked</span>
              </button>
              <div className="locked-section-popup">
                <p>The section is temporarily locked as it is currently being edited by:</p>
                <div className="pop-footer">
                  <div className="circle">{chapter?.locked_user?.split(" ").map((n) => n[0]).join("")}</div>
                  <span className="name">{chapter?.locked_user}</span>
                </div>
              </div>
            </div>}
          {/* Locked Section end */}
          {/* Progress circle */}
          <div style={{ visibility: sectionDataItem.noline == "" && index == 8 ? 'hidden' : '' }} className="text-cir">
            <SvgCircle value={chapter.catprogress} />
          </div>
        </div>
        {/*  Right section for navigate to next page */}
        <div style={{ visibility: sectionDataItem.noline == "" && index == 8 ? 'hidden' : '' }} className="angle-box">
          <img src={require("../../assets/img/all-section/right-angle.svg").default } alt="true" />
        </div>

        {/* popup that will show on card hover */}
        <div className={`sellection-card-popup ${index > 6 && "last-popup"} ${sectionLockedHover ? ' sellection-card-popup-hidden' : ''}`}>
          <h2>{chapter.category_name}</h2>
          <div
            dangerouslySetInnerHTML={{ __html: chapter.category_description }}
          ></div>
        </div>
      </a>
    );
    // }
  });

  const user = JSON.parse(localStorage.getItem("group_id"));
  const group_id = user ? user : 0;
 
  //Function to handle Plant Admin
  const handleplantAdmin = () => {
    // console.log("hello");
    if (group_id == 11) {
      window.location = "/maturity-dashboard-admin";
    } else {
      window.location = "/maturity-dashboard";
    }
  };

  const uid = sectionDataItem.uid;
  const plantid = sectionDataItem.plant_id;
  //Function to handle result page
  const handleresultpage = () => {
    setDistext("Submitting Input...");
    serviceProvider
      .post(
        "/resultsmaturityassess?type=calculate",
        JSON.stringify({ plant_id: plantid, user_id: uid }, true)
      )
      .then((response) => {
        //console.log(response);
        window.location = `/result/${slug}`;
        setDistext("Submit your input");
      });
    // window.location = "/result";
  };

  return (
    <>
      {/* Page Title */}
      <Helmet>
        <title>Assessment | SmarterChains</title>
        <meta name="description" content={`Assessment`} />
      </Helmet>
      {/* Breadcrumbs */}
      <BreadcrumbsItem to="/">Home</BreadcrumbsItem>
      <BreadcrumbsItem to={`/assessment/${slug}`} onClick={() => setIsProductionPopup(false)}>Assessment</BreadcrumbsItem>
      {isProductionPopup && <BreadcrumbsItem to="#">Production Lines Setup</BreadcrumbsItem>}
      {/* assessment wrapper start ("assessment-main" class added for custom changes)*/}
      <div className="all-sellection-main assessment-main">
        <div className="asst-plant-details-wrapper"
          style={{ display: sectionDataItem.noline == "" && (group_id == 11 || group_id == 2 || sectionDataItem.open_line == 1) ? "block" : "none" }}
        >
          {/*hide this button for SCNV-2147*/}
          {/*<button
                      className="addPlantLines"
                      onClick={() => setIsProductionPopup(true)}      
                    >
                      <img
                        src={
                          require("../../assets/img/production-line/bg-yellow-i-icon.svg")
                            .default
                        }
                        alt=""
                      />
                      <span>Plant details</span>
                    </button>
            */}
          {/* end hide this button for SCNV-2147*/}
        </div>
        {/* left section of assessment section which has card,responsible-text,assign/unassign user, progress circle and angle button to navigate next page.
        ("asst-card" class replaced from left-assessment-section for right-assessment section) */}
        <div className="left-assessment-section calc-button-wrap">
          {chapterDataItemSections}
          {(sectionDataItem.progress == 100 && (group_id == 11 || group_id == 2 )) ? (
            // footer buttons that is come conditional.
            <div className="res-calc-btn-div">
              <button
                disabled={false}
                className="result-calc-btn"
                onClick={handleresultpage}
              >
                {distext}
              </button>
            </div>
          ) : (
            <div className="res-calc-btn-div">
              <button className="result-calc-btn" onClick={handleplantAdmin}>
                Go to plant page
              </button>
            </div>
          )}
        </div>
        {/* Assessment Right section changes start. Section has divided into two horizontal parts.*/}
        <div className="right-assessment-section">
          {/* top section containing progress of assessment */}
          <div className="top-progress-bar">
            <div className="progress-bar-section">
              <div className="header-progress">
                <p className="progress-title">Overall Progress:</p>
                <h2>{sectionDataItem.progress}%</h2>
                <div className="header-progress-bar">
                  <div style={{width:sectionDataItem.progress+'%'}}></div>
                </div>
              </div>
            </div>
            <div className="submit-section-count">
              <span className="heading">Sections Submitted: </span>
              {/* "sections submitted" wiill be replace from "sections completed" when the all sections will be completed */}
              <div className="count">
                {sectionDataItem.locked_sections} / {totalCat}
              </div>
			  {(sectionDataItem.is_datasubmitted == 1 && group_id == 14) &&(
            <>
              <div className="submit-text pro">
                    <img src={require("../../assets/img/assessment-right-section/green-check.svg").default} alt="Green Check" />
                    <span>Data Submitted</span>
              </div>
            </>
          )}
             
            </div>
          </div>
          {/* Submission section which will come conditional */}
          {(isPlanSubmit && (group_id == 11 || group_id == 2)) && (
            <div className="assessment-submission-section">
              <div className="top-sec">
                {(sectionDataItem.progress == 100 && (group_id == 11 || group_id == 2)) ? (
                  <span>Action required</span>
                ) : (
                  <span className="progress-text">Assessment In-Progress</span>
                )}
              </div>
              <div className="bottom-content-section">
                <p className="bottom-content">When all sections are complete, click the "Submit Data" button to finalize the assessment.</p>
              </div>
              <div className="button-wrap"> 
                <button className={`submit-btn ${(sectionDataItem.progress == 100 && (sectionDataItem.locked_sections == totalCat) && (group_id == 11 || group_id == 2))?'active':''}`} disabled={(sectionDataItem.progress == 100 && (sectionDataItem.locked_sections == totalCat) && (group_id == 11 || group_id == 2))?false:true} onClick={() => setIsSubmitPop(!isSubmitPop)}>Submit Data</button>
              </div>
            </div>
          )}
          {(isFinalSubmit && (group_id == 11 || group_id == 2) ) &&(
            <>
              <div className="assessment-submission-section final-submit">
                <div className="top-sec">
                  <span>No further action required</span>
                </div>
                <div className="bottom-content-section">
                  <p>Your data have been successfully submitted.</p>
                </div>
                <div className="button-wrap">
                  <div className="submit-text">
                    <img src={require("../../assets/img/assessment-right-section/green-check.svg").default} alt="Green Check" />
                    <span>Data Submitted</span>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {/* Submit Popup for assessment right section start*/}
        {isSubmitPop && (
          <div className="popup-box-blue" >
            <div className="center-box">
              <div className="content-section">
                <h2>Are you sure, you would like to submit your data?</h2>
                <p>Please note, that you will not be able to make changes after submission.</p>
                <div className="button-section">
                  <button className="cancel" onClick={() => setIsSubmitPop(!isSubmitPop)}>Cancel</button>
                  <button className="submit" onClick={() => handleFinalSubmit()}>Yes, submit</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* assessment right  section end*/}
      </div>
      {/* UPGRADE POPUP start */}
      <Modal
        open={isUpgradePopup}
        // onClose={HandleUpdgradePopup}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className="home-index-upgrade-popup"
      >
        <div className="upgrade-popup-content">
          {/* Close button to close popup */}
          <button className="close-btn" onClick={HandleUpdgradePopup}>
            <img src={require("../../assets/img/common-img/close-icon-blue.svg").default} alt="close"/>
          </button>
          {/* section that is containing image */}
          <div className="upgrd-popup-img">
            <img src={require("../../assets/img/home-index/digital-maturity.gif").default} alt="digital_maturity"/>
          </div>
          {/* Section that is containing heading and text */}
          <div className="upgrd-popup-body">
            <h2 className="h1">
              Buy full Digital Maturity Assessment to Unlock Plants
            </h2>
            <p>
              Upgrade to the plan that best matches your profile and start the
              Assessment as early as today.
            </p>
            <Link
              to="/plans"
              className="btn-upgrade-now"
              onClick={HandleUpdgradePopup}
            >
              Upgrade Now{" "}
            </Link>
          </div>
        </div>
      </Modal>
      {/* {isAssessmenttour != 1 &&
      <AdminWalkthroughController handleGetValue={handleGetValue} isusers={isusers} />

       } */}
       {/* Assessment walkthrough component call conditionally for first time login user/admin */}
       {isAssessmenttour != 1 &&
        <AssessmentWalkthroughView handleGetValue={handleGetValue} isusers={isusers}/>
        }
      {/* Production Line popup has started */}
      <ProductionLinePop
        open={isProductionPopup}
        datasec={sectionDataItem}
        setOpen={setIsProductionPopup}
        uid={uid}
        getAssessmentDetails={props.getAssessmentDetails}
      />
      {/* Assign user popup component call */}
      <AssignSectionPopup
        assignedUsers={assignedUsers}
        setAssignedUsers={setAssignedUsers}
        catagory={cate}
        catagoryName={catename}
        plant_id={plantid}
        tmpAssignUser={tmpAssignUser}
        open={isAssignSectionPopup}
        setOpen={setIsAssignSectionPopup}
        {...props}
      />
    </>
  );
};
// svgcircle component which is used for progress circle on assessment and chapter pages
const SvgCircle = (props) => {
  const { value } = props;
  return (
    <svg className="percent__svgs" viewBox="0 0 36 36">
      <text
        className="percent__text"
        x="50%"
        y="53%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="10"
        fontWeight="600"
      >
        {value}
        <tspan fontSize="5">%</tspan>
      </text>
      <path
        className="circle-bg"
        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831
                                            a 15.9155 15.9155 0 0 1 0 -31.831"
        stroke="#EBF5FA"
        strokeWidth="2.4"
        fill="none"
      ></path>
      <path
        className="circle"
        strokeDasharray={`${value}, 100`}
        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
        stroke={
          value < 100 && value > 0
            ? "#FFBC1F"
            : value === 100
              ? "#40D30D"
              : "transparent"
        }
        strokeWidth="2.4"
        fill="none"
      ></path>
    </svg>
  );
};
//Function for production line popup
const ProductionLinePop = (props) => {
  const handleClose = () => {
    props.setOpen(false);
  };

  //   const [inputvalue, setInputvalue] = useState([]);
  const [planCardArr, setPlanCardArr] = useState([
    0, 1, 2
  ]);

  const [lastshowpop, setlastshowpop] = useState('hide-class');
  const [planCardData, setPlanCardData] = useState([]);
  const [isBtnDisaled,setIsBtnDisaled] = useState(true);


  useEffect(() => {
    let plant_id = props.datasec.plant_id;
    let user_id = props.datasec.uid;
    const apiUrl = `/assessmentmaturity?param=autosave&plantid=${plant_id}&uid=${user_id}`;
    serviceProvider
      .get(apiUrl, true, {}).then(response => {
        const { data: data_lines } = response;
        if (data_lines.length) {
          setPlanCardData(data_lines);
          setPlanCardArr([...Array(data_lines.length).keys()]);
		  let tmp = 0;
		  $("input[name='productionLines[]']").each(function () {
			  if($(this).val() == ''){
				 tmp=1;
			  }
    	   });
		    if(tmp == 0){
		    	setIsBtnDisaled(false);
			}
        }

      }).catch(error => {
        console.log(error)
      })
  }, [])

  const handleAdd = () => {
    let tmpArr = [...planCardArr];
    tmpArr.push(tmpArr.length);
    setPlanCardArr(tmpArr);
	let count = 1; 
	let hascount = 0;
    $("input[name='productionLines[]']").each(function () {
	  if($(this).val() != ''){
		  hascount++;
	  }
	  count++;
    });
	
	if(count==hascount){
		setIsBtnDisaled(false);
	}else{
		setIsBtnDisaled(true);
		}

  };
 
  const removeInput = (e,index) => {
    let targetIndex = index;
    let tmpArr =[...planCardArr];
	
	tmpArr.splice(index, 1);
	setPlanCardArr(tmpArr);
	
	let tempData = [...planCardData];
	tempData.splice(index, 1);
	
	setPlanCardData(tempData)
    let count = -1; 
	let hascount = 0;
    $("input[name='productionLines[]']").each(function () {
	  if($(this).val() != ''){
		  hascount++;
	  }
	  count++;
    });
	if(count==0){
		setIsBtnDisaled(true);
	}

  };

  const validation = (e) => {
    e.preventDefault();
    var error = false;

    $("input[name='productionLines[]']").each(function (index, value) {
      var id = "lError" + $(this).attr("id").substr(8);

      // console.log($(this).val());
      if ($(this).val().length == 0) {
        $("#" + id).text("Line name required.");
        error = true;
        // return;
      } else {
        $("#" + id).text("");
        error = false;
      }
    });
    $("input[name='productionLines[]']").each(function (index, value) {
      // var error = false;
      if ($(this).val() != "") {
        if (checkLineName($(this).val()) > 1) {
          $("#plantLineError").text(
            "The Production Lines name must be unique."
          );
          error = true;
          return false;
        } else {
          $("#plantLineError").text("");
        }
      } else {
        error = true;
        return false;
      }
    });
    if (!error) {
      setlastshowpop('')
    }
  };
  function checkLineName(lineName) {
    var counter = 0;
    $("input[name='productionLines[]']").each(function (index, value) {
      if ($(this).val() == lineName) {
        counter++;
      }
    });
    return counter;
  }

  const saveData = (e) => {

    e.preventDefault();
    var plantid = $(e.target).attr("data-plantid");
    var userid = $(e.target).attr("data-userid");

    var values = [];
    $("input[name='productionLines[]']").each(function () {
      values.push($(this).val());
    });
    serviceProvider.post("/assessmentmaturity?type=plantline", JSON.stringify({ plant_id: plantid, user_id: userid, line_name: values }), true)
      .then(async (response) => {
        await props.getAssessmentDetails();
        props.setOpen(false);
      }).catch((error) => { return error; });
  };

  const [walkthroughClose, setWalkthroughClose] = useState(true)

  const handelCloseWalkThrough = () => {
    document.querySelectorAll('.highlightnew').forEach((item) => {
      item.classList.remove('highlightnew');
    })
    document.querySelectorAll('.change-col-length').forEach((item) => {
      item.classList.remove('change-col-length');
    })
    document.querySelector(".plant-details-popup").classList.remove("highlighttxt");
    serviceProvider
      .post(
        "/home?type=setproductionline",
        JSON.stringify({ uid: props.uid }), true
      )
      .then((response) => {
        setWalkthroughClose(false);
      });

  }
  useEffect(() => {
    if (props.datasec.isproductiontour != 1) {
      document.querySelector(".plant-details-popup").classList.add("highlighttxt");
      document.querySelector(".plant-detail-left .text-right").classList.add("highlightnew");
      document.querySelector(".plant-detail-left .text-right").classList.add("ex-border");
      document.querySelector(".plant-one-card-wrapper").classList.add("highlightnew");
      document.querySelector(".pl-d-add-more-btn").classList.add("highlightnew");
      document.querySelectorAll('.col-7').forEach((item) => {
        item.classList.add('change-col-length');
      })
    }
    else { }
  }, [])

  const handleChange = (e, index, action = "edit") => {
       let tempData = [];
       $("input[name='productionLines[]']").each(function () {
            tempData.push({ line_name: $(this).val() });
       });
       setPlanCardData(tempData)
  }

  const autoSave = _.debounce(function () {
     var values = [];
	 let count = 0; 
	 let hascount = 0;
    $("input[name='productionLines[]']").each(function () {
      values.push($(this).val());
	  if($(this).val() != ''){
		  hascount++;
	  }
	  count++;
    });
	if(count==hascount && values.length !=0){
			setIsBtnDisaled(false);
	}else{
		setIsBtnDisaled(true);
		}
	
	 
    serviceProvider
      .post(
        "/assessmentmaturity?type=plantline_autosave", JSON.stringify({ plant_id: props.datasec.plant_id, user_id: props.datasec.uid, line_name: values }), true)
      .then(async (response) => {
      }).catch((error) => { console.error() });

  }, 300)



  return (
    <>
      <div
        style={{ display: props.open ? "block" : "none" }}
        className="production-line-popup"
      >
        <div className="production-line-wrap">
          <div
            className={`plant-details-popup  ${!!lastshowpop ? '' : 'production-line-popup-active'}`}
            id="plantDetailsPopup"
            style={{}}
          >
            <div className="asst-abt-content-body plant-dtails-body">
              <div className="row no-gutters px-0">
                <div className="col asst-abt-left">
                  <div className="main-flex-asstdiv">
                    <div className="asstdiv-top">
                      <div className="d-flex ml-auto admin-page-empty-wrapper no-assesed-wrapper px-0">
                        <div className="col-7 admin-page-empty-left">
                          <div className="plant-detail-left">
                            <h2 className="asst-h1">Production Lines Setup</h2>
                            <p className="plant-details-para">
                              Please list the production lines that you would like
                              to assess below.
                            </p>
                            <p className="plant-details-para">
                              You can enter as many lines as you want, but we
                              recommend to list up to 10 lines for a better
                              assessment experience.
                            </p>
                            <p className="plant-details-para">
                              Please note that after you submit your lines, you will
                              not have the option to change them.
                            </p>
                          </div>
                        </div>
                        <div className="col-5">
                          <div className="pl-right-div d-flex align-items-center">
                            <div className="col-1 px-0">
                              <img
                                src={
                                  require("../../assets/img/production-line/carbon_idea.svg")
                                    .default
                                }
                                alt=""
                                className="w-100"
                              />
                            </div>
                            <div className="col-11 py-0 pl-d-pl-30">
                              A good practice is to group production lines with
                              identical technology stacks and process flows into
                              single items for the assessment.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*asstdiv-top end*/}
                    <div className="asstdiv-list">
                      <div className="d-flex ml-auto admin-page-empty-wrapper no-assesed-wrapper px-0 pb-0 pt-0">
                        <div className="col-7 admin-page-empty-left">
                          <div className="plant-detail-left">
                            <div className="plant-detail-card-wrapper">
                              {/* {inputvalue.map((item, index)=>{
                              return( */}
                              {planCardArr.map((item, index) => (
                                <div className="plant-one-card-wrapper" id={`plantCard${index}`} key={`plantCard${index}`}>
                                  <div className="plant-details-card">
                                    <div className="pl-d-card-left">{index + 1}</div>
                                    <div className="pl-d-content">
                                      <div className="content-lft">
                                        {/* Changes related to SCNV-2245 */}
                                        <input
                                          type="text"
                                          name="productionLines[]"
                                          id={`prodline${index + 1}`}
                                          placeholder="Line Name"
                                          maxlength
                                          className="w-100 pl-card-txt border-0"
                                          onChange={(e) => { handleChange(e, index); autoSave() }}
                                          value={planCardData[index] ? planCardData[index].line_name : ''}
                                        />
                                        {/* Changes related to SCNV-2245 */}
                                      </div>
                                      <a
                                        className="content-rgt"
                                        onClick={(e) => {
                                          removeInput(e,index);
                                          autoSave()
                                        }}
                                      >
                                        <img
                                          src={
                                            require("../../assets/img/production-line/plant-del-icon.svg")
                                              .default
                                          }
                                          alt=""
                                        />
                                      </a>
                                    </div>
                                  </div>
                                  <sapn
                                    id={`lError${index + 1}`}
                                    className="error-txt d-block"
                                    style={{ display: "block" }}
                                  >
                                    {" "}
                                  </sapn>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="col-5">
                        </div>
                      </div>
                      <div className="d-flex ml-auto admin-page-empty-wrapper no-assesed-wrapper px-0 pt-0">
                        <div className="col-7 admin-page-empty-left">
                          <div className="plant-detail-left">

                            <a
                              href="javascript:void(0)"
                              className="pl-d-add-more-btn"
							  onClick={(e) => {
                                          handleAdd();
                                          autoSave()
                                        }}
                              
                               >
                              {" "}
                              <span>+</span>Add More
                            </a>
                            <br />
                            <small
                              id="plantLineError"
                              style={{ color: "red", fontSize: 10 }}
                            >
                              {" "}
                            </small>
                            <div className="text-right">
                              {/* <button
                                onClick={handleClose}
                                className="pl-d-save-line-btn close-popup-btn"
                                data-target="plantDetailsPopup"
                              >
                                Cancel
                              </button> */}
                              <button
                                className="pl-d-save-line-btn saveConfirm"
                                data-plantid={props.datasec.plant_id}
                                data-userid={props.datasec.uid}
                                disabled={isBtnDisaled}
                                onClick={(e) => {
                                  validation(e)
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*asstdiv-list end*/}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        {walkthroughClose && props.datasec.isproductiontour != 1 ?
          <div className="admin-wakthrough-modal">
            <div className="admin-walkthrough">
              {/* <div className="bg-admin">
                            <img src={require(`../../assets/img/admin-walkthrough/admin-bg-${slideIndex}.svg`).default} alt={`admin-bg-${slideIndex}`} />
                        </div> */}
              <div className="carousel-wrapper left">
                <button className="modal-close " onClick={() => { handelCloseWalkThrough() }}>
                  <img src={require("../../assets/img/admin-walkthrough/close.svg").default} alt="X" />
                </button>

                <div className="slide-item">
                  <div className="left-frame">
                    <img src={require(`../../assets/img/admin-walkthrough/production.gif`).default} alt="fiftyfive" />
                  </div>
                  <div className="right-frame">
                    <div className="slide-content">
                      <h2 className="slide-h1">Production Lines Setup</h2>
                      <p className="slide-p">
                        Insert the name of the production lines you would like to assess and submit them when ready.
                      </p>
                      <p className="slide-p">Remember that you can not change your input after submission.</p>
                    </div>
                    <div className="slide-footer">
                      <div className="button-div">
                        <button className="blue" onClick={() => { handelCloseWalkThrough() }}>
                          OK
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* slide 1 end */}
              </div>
            </div>
          </div>
          : null}
        {/* Submit pop up start */}
        <div className={`submit-popup-ast active ${lastshowpop}`}>
          <div className="popup-wrapper submitdata-popup">
            <div className="close-btn-wrap">
              <button className="close-btn" onClick={() => { setlastshowpop('hide-class') }}>
                <img src={require("../../assets/img/la-admin/close-pop.svg").default} alt="Close" className="close-img" />
              </button>
            </div>
            <div className="popup">
              <div className="content-box">
                <SubmitSvg />
                <p className="text">By submitting the data you will no longer have the opportunity for futher editing.</p>
                <p className="text">Are you sure you want to proceed</p>

              </div>
              <div className="button-wrapper">
                <button type="submit" className="btn cancel-button primary" onClick={() => { setlastshowpop('hide-class') }}>Cancel</button>
                <button type="submit"
                  className="btn submit-btn secondary"
                  data-plantid={props.datasec.plant_id}
                  data-userid={props.datasec.uid}
                  onClick={(e) => { saveData(e) }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Submit pop up end */}
      </div>
    {/* Assessment Walkthrough */}

    </>
  );
};


// Assessment Page Walkthrough

const AssessmentWalkthroughView = (props) => {

  //Variable Declaration
  const users = JSON.parse(localStorage.getItem("userData"));
  const UserName = users ? users.name : "First Name";
  const uid = users ? users.uid : "";
  const user = JSON.parse(localStorage.getItem("group_id"));
  const group_id = user ? user : 0;
  const [sliderStatus, setSliderStatus] = useState(1);
  //Function to slide wlakthrough from one to next
  const HandleSlider = (val) => {
    setSliderStatus(val);
  }
  //Function to close the slider
  const handleClose = () => {

    serviceProvider
    .post(
        "/home?type=setassessment",
        JSON.stringify({ uid: uid }),
        true
      )
      .then((response) => {
        setSliderStatus(0);
      });
  }
  //Conditions to add and remove dynamic classes as per requirement for walkthrough
  useEffect(() => {
    if (sliderStatus === 2) {
      document.querySelector('.training-header').classList.add('div-z99');
      document.querySelector('.ng-sidebar').classList.add('div-zremove');
      document.querySelector('.training-content').classList.add('div-z99');
    }
    else {
      document.querySelector('.training-header').classList.remove('div-z99');
      document.querySelector('.ng-sidebar').classList.remove('div-zremove');
      document.querySelector('.training-content').classList.remove('div-z99');
    }
    if (sliderStatus === 3) {
      document.querySelector('.training-content').classList.add('div-z992');
    }
    else {
      document.querySelector('.training-content').classList.remove('div-z992');
    }
    if (sliderStatus === 4) {
      document.querySelector('.training-content').classList.add('div-z993');
    }
    else {
      document.querySelector('.training-content').classList.remove('div-z993');
    }
    if (sliderStatus === 5) {
      document.querySelector('.training-content').classList.add('div-z994');
      // window.scrollBy(0,50);
    }
    else {
      document.querySelector('.training-content').classList.remove('div-z994');
    }
    if (sliderStatus === 6) {
      document.querySelector('.training-content').classList.add('div-z995');
    }
    else {
      document.querySelector('.training-content').classList.remove('div-z995');
    }
  }, [sliderStatus]);

  return (
    <>
      {/* link css */}
      <Helmet>
        <link rel="stylesheet" href={require('./assess-walkthrough.scss').default} />
      </Helmet>
      {/* link css end*/}
      {/* Condition for assessment walkthrough for admin and user */}
     { (group_id == 11 || group_id == 2) ?
      (
        <>
          {/* Assessment walkthrough for admin */}
          <section className="general-information-walkthrough">
            <div className="general-information-top">
              {/*---------------------  Walkthrough Wrapper  ------------------------*/}
              <div className="general-info-walkthrough">
                {sliderStatus === 1 ?
                  <div className="g-walkthrough-screen1 gstep">
                    {/* walkthrough wrapper start */}
                    <div className="g-walkthrough-wrapper">
                      {/* walkthrough wrapper divided in two parts */}
                      <div className="g-walk-row">
                        {/* left part is containing gif image related to walkthrough step. */}
                        <div className="g-walk-col-left">
                          <img src={require("../../assets/img/assessment-walkthrough/asmt-step1.gif").default} alt="Question Step 1" />
                        </div>
                        {/* right part has heading, text and buttons navigate from one to next, next to previous and close. */}
                        <div className="g-walk-col-right">
                          <div className="col-right-card-wrap">
                            <div className="card-header">
                              <div className="left-text-wrap">
                                <p>1 of 6</p>
                              </div>
                              <div className="close-btn">
                                <button className="close" onClick={handleClose}><img src={require("../../assets/img/chapter-walkimg/close-gray.svg").default} alt="digital_maturity" /></button>
                              </div>
                            </div>
                            <div className="card-body">
                              <h4 className="heading">Hi <span>{UserName}</span></h4>
                              <p className="txt">Welcome to the Industry 4.0 Maturity Assessment.​</p>
                              <p className="txt">We want to quickly show you around. You can skip at any time.​</p>
                            </div>
                            <div className="card-footer">
                              <div className="card-footer-section">
                                <div className="card-footer-left">
                                  <button className="circle" onClick={() => { HandleSlider(1) }} disabled={sliderStatus === 1 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(2) }} disabled={sliderStatus === 2 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(3) }} disabled={sliderStatus === 3 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(4) }} disabled={sliderStatus === 4 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(5) }} disabled={sliderStatus === 5 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(6) }} disabled={sliderStatus === 6 ? true : false}></button>
                                </div>
                                <div className="card-footer-right">
                                  <button className="prev-link link" onClick={handleClose}>No thanks</button>
                                  <button onClick={() => { HandleSlider(2) }} className="link solid">Let’s go</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  : null}
                {sliderStatus === 2 ?
                  <div className="g-walkthrough-screen2 gstep">
                    {/* walkthrough wrapper start */}
                    <div className="g-walkthrough-wrapper">
                      {/* walkthrough wrapper divided in two parts */}
                      <div className="g-walk-row">
                        {/* left part is containing gif image related to walkthrough step. */}
                        <div className="g-walk-col-left"><img src={require("../../assets/img/assessment-walkthrough/asmt-step2.gif").default} alt="Question Walkthrough" className="close-img" /></div>
                        {/* right part has heading, text and buttons navigate from one to next, next to previous and close. */}
                        <div className="g-walk-col-right">
                          <div className="col-right-card-wrap">
                            <div className="card-header">
                              <div className="left-text-wrap">
                                <p>2 of 6</p>
                              </div>
                              <div className="close-btn">
                                <button className="close" onClick={handleClose}><img src={require("../../assets/img/chapter-walkimg/close-gray.svg").default} alt="digital_maturity" /></button>
                              </div>
                            </div>
                            <div className="card-body">
                              <h4 className="heading">Assessment Basics</h4>
                              {/*comment2*/}
                              <p className="txt">This is the Assessment's main interface.​</p>
                              <p className="txt">Track the overall and each section's progress. Use the top navigation to move around.</p>
                            </div>
                            <div className="card-footer">
                              <div className="card-footer-section">
                                <div className="card-footer-left">
                                  <button className="circle" onClick={() => { HandleSlider(1) }} disabled={sliderStatus === 1 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(2) }} disabled={sliderStatus === 2 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(3) }} disabled={sliderStatus === 3 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(4) }} disabled={sliderStatus === 4 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(5) }} disabled={sliderStatus === 5 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(6) }} disabled={sliderStatus === 6 ? true : false}></button>
                                </div>
                                <div className="card-footer-right">
                                  <button onClick={() => { HandleSlider(1) }} className="prev-link link">Previous</button>
                                  <button onClick={() =>{ HandleSlider(3) }} className="let link solid">Next</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  : null}
                {sliderStatus === 3 ?
                  <div className="g-walkthrough-screen3 gstep">
                     {/* walkthrough wrapper start */}
                    <div className="g-walkthrough-wrapper">
                       {/* walkthrough wrapper divided in two parts */}
                      <div className="g-walk-row">
                        {/* left part is containing gif image related to walkthrough step. */}
                        <div className="g-walk-col-left"><img src={require("../../assets/img/assessment-walkthrough/asmt-step3.gif").default} alt="Question Walkthrough" className="close-img" /></div>
                        {/* right part has heading, text and buttons navigate from one to next, next to previous and close. */}
                        <div className="g-walk-col-right">
                          <div className="col-right-card-wrap">
                            <div className="card-header">
                              <div className="left-text-wrap">
                                <p>3 of 6</p>
                              </div>
                              <div className="close-btn">
                                <button className="close" onClick={handleClose}><img src={require("../../assets/img/chapter-walkimg/close-gray.svg").default} alt="digital_maturity" /></button>
                              </div>
                            </div>
                            <div className="card-body">
                              <h4 className="heading">Assessment Collaboration​</h4>
                              {/*comment2*/}
                              <p className="txt">Learn more information about each section.​</p>
                              <p className="txt">Invite your colleagues to answer them using their email address.</p>
                            </div>
                            <div className="card-footer">
                              <div className="card-footer-section">
                                <div className="card-footer-left">
                                  <button className="circle" onClick={() => { HandleSlider(1) }} disabled={sliderStatus === 1 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(2) }} disabled={sliderStatus === 2 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(3) }} disabled={sliderStatus === 3 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(4) }} disabled={sliderStatus === 4 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(5) }} disabled={sliderStatus === 5 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(6) }} disabled={sliderStatus === 6 ? true : false}></button>
                                </div>
                                <div className="card-footer-right">
                                  <button onClick={() => { HandleSlider(2) }} className="prev-link link">Previous</button>
                                  <button onClick={() =>{ HandleSlider(4) }} className="let link solid">Next</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  : null}
                {sliderStatus === 4 ?
                  <div className="g-walkthrough-screen3 gstep">
                     {/* walkthrough wrapper start */}
                    <div className="g-walkthrough-wrapper">
                      {/* walkthrough wrapper divided in two parts */}
                      <div className="g-walk-row">
                        {/* left part is containing gif image related to walkthrough step. */}
                        <div className="g-walk-col-left"><img src={require("../../assets/img/assessment-walkthrough/asmt-step4.gif").default} alt="Question Walkthrough" className="close-img" /></div>
                       {/* right part has heading, text and buttons navigate from one to next, next to previous and close. */}
                        <div className="g-walk-col-right">
                          <div className="col-right-card-wrap">
                            <div className="card-header">
                              <div className="left-text-wrap">
                                <p>4 of 6</p>
                              </div>
                              <div className="close-btn">
                                <button className="close" onClick={handleClose}><img src={require("../../assets/img/chapter-walkimg/close-gray.svg").default} alt="digital_maturity" /></button>
                              </div>
                            </div>
                            <div className="card-body">
                              <h4 className="heading">Select a Section</h4>
                              {/*comment2*/}
                              <p className="txt">Click on the arrow to access the section and view its chapters.</p>
                              <p className="txt">Navigate through and complete the questionnaire(s) you have been assigned to.</p>
                            </div>
                            <div className="card-footer">
                              <div className="card-footer-section">
                                <div className="card-footer-left">
                                  <button className="circle" onClick={() => { HandleSlider(1) }} disabled={sliderStatus === 1 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(2) }} disabled={sliderStatus === 2 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(3) }} disabled={sliderStatus === 3 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(4) }} disabled={sliderStatus === 4 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(5) }} disabled={sliderStatus === 5 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(6) }} disabled={sliderStatus === 6 ? true : false}></button>
                                </div>
                                <div className="card-footer-right">
                                  <button onClick={() => { HandleSlider(3) }} className="prev-link link">Previous</button>
                                  <button onClick={() =>{ HandleSlider(5) }} className="let link solid">Next</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  : null}
                {sliderStatus === 5 ?
                  <div className="g-walkthrough-screen4 gstep">
                     {/* walkthrough wrapper start */}
                    <div className="g-walkthrough-wrapper">
                      {/* walkthrough wrapper divided in two parts */}
                      <div className="g-walk-row">
                        {/* left part is containing gif image related to walkthrough step. */}
                        <div className="g-walk-col-left"><img src={require("../../assets/img/assessment-walkthrough/asmt-step5.gif").default} alt="Question Walkthrough" className="close-img" /></div>
                        {/* right part has heading, text and buttons navigate from one to next, next to previous and close. */}
                        <div className="g-walk-col-right">
                          <div className="col-right-card-wrap">
                            <div className="card-header">
                              <div className="left-text-wrap">
                                <p>5 of 6</p>
                              </div>
                              <div className="close-btn">
                                <button className="close" onClick={handleClose}><img src={require("../../assets/img/chapter-walkimg/close-gray.svg").default} alt="digital_maturity" /></button>
                              </div>
                            </div>
                            <div className="card-body">
                              <h4 className="heading">Unlock Production Execution</h4>
                              {/*comment2*/}
                              <p className="txt">In order to unlock the section, you or another team member, need to set up the production lines.</p>
                            </div>
                            <div className="card-footer">
                              <div className="card-footer-section">
                                <div className="card-footer-left">
                                  <button className="circle" onClick={() => { HandleSlider(1) }} disabled={sliderStatus === 1 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(2) }} disabled={sliderStatus === 2 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(3) }} disabled={sliderStatus === 3 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(4) }} disabled={sliderStatus === 4 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(5) }} disabled={sliderStatus === 5 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(6) }} disabled={sliderStatus === 6 ? true : false}></button>
                                </div>
                                <div className="card-footer-right">
                                  <button onClick={() => { HandleSlider(4) }} className="prev-link link">Previous</button>
                                  <button onClick={() =>{ HandleSlider(6) }} className="let link solid">Next</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  : null}
                {sliderStatus === 6 ?
                  <div className="g-walkthrough-screen5 gstep">
                    {/* walkthrough wrapper start */}
                    <div className="g-walkthrough-wrapper">
                      {/* walkthrough wrapper divided in two parts */}
                      <div className="g-walk-row">
                        {/* left part is containing gif image related to walkthrough step. */}
                        <div className="g-walk-col-left"><img src={require("../../assets/img/assessment-walkthrough/asmt-step6.gif").default} alt="Question Walkthrough" className="close-img" /></div>
                        {/* right part has heading, text and buttons navigate from one to next, next to previous and close. */}
                        <div className="g-walk-col-right">
                          <div className="col-right-card-wrap">
                            <div className="card-header">
                              <div className="left-text-wrap">
                                <p>6 of 6</p>
                              </div>
                              <div className="close-btn">
                                <button className="close" onClick={handleClose}><img src={require("../../assets/img/chapter-walkimg/close-gray.svg").default} alt="digital_maturity" /></button>
                              </div>
                            </div>
                            <div className="card-body">
                              <h4 className="heading">Submit Data</h4>
                              {/*comment2*/}
                              <p className="txt">When all Sections are submitted, you will need to finalize the submission using the key actions interface.</p>
                            </div>
                            <div className="card-footer">
                              <div className="card-footer-section">
                                <div className="card-footer-left">
                                  <button className="circle" onClick={() => { HandleSlider(1) }} disabled={sliderStatus === 1 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(2) }} disabled={sliderStatus === 2 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(3) }} disabled={sliderStatus === 3 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(4) }} disabled={sliderStatus === 4 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(5) }} disabled={sliderStatus === 5 ? true : false}></button>
                                  <button className="circle" onClick={() => { HandleSlider(6) }} disabled={sliderStatus === 6 ? true : false}></button>
                                </div>
                                <div className="card-footer-right">
                                  <button onClick={() => { HandleSlider(1) }} className="prev-link link">Restart</button>
                                  <button onClick={() => handleClose()} className="let link solid">Close</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  : null}
              </div>
            </div>
          </section>
        </>
      )
      : 
      (
      <>
      {/* Assessment walkthrough for user */}
      <section className="general-information-walkthrough">
        <div className="general-information-top">
          {/*---------------------  Walkthrough Wrapper  ------------------------*/}
          <div className="general-info-walkthrough">
            {sliderStatus === 1 ?
              <div className="g-walkthrough-screen1 gstep">
                 {/* walkthrough wrapper start */}
                <div className="g-walkthrough-wrapper">
                   {/* walkthrough wrapper divided in two parts */}
                  <div className="g-walk-row">
                    {/* left part is containing gif image related to walkthrough step. */}
                    <div className="g-walk-col-left">
                      <img src={require("../../assets/img/assessment-walkthrough/asmt-step1.gif").default} alt="Question Step 1" />
                    </div>
                     {/* right part has heading, text and buttons navigate from one to next, next to previous and close. */}
                    <div className="g-walk-col-right">
                      <div className="col-right-card-wrap">
                        <div className="card-header">
                          <div className="left-text-wrap">
                            <p>1 of 4</p>
                          </div>
                          <div className="close-btn">
                            <button className="close" onClick={handleClose}><img src={require("../../assets/img/chapter-walkimg/close-gray.svg").default} alt="digital_maturity" /></button>
                          </div>
                        </div>
                        <div className="card-body">
                          <h4 className="heading">Hi <span>{UserName}</span></h4>
                          <p className="txt">Welcome to the Industry 4.0 Maturity Assessment.​</p>
                          <p className="txt">We want to quickly show you around. You can skip at any time.​</p>
                        </div>
                        <div className="card-footer">
                          <div className="card-footer-section">
                            <div className="card-footer-left">
                              <button className="circle" onClick={() => { HandleSlider(1) }} disabled={sliderStatus === 1 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(2) }} disabled={sliderStatus === 2 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(3) }} disabled={sliderStatus === 3 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(4) }} disabled={sliderStatus === 4 ? true : false}></button>
                            </div>
                            <div className="card-footer-right">
                              <button className="prev-link link" onClick={handleClose}>No thanks</button>
                              <button onClick={() => { HandleSlider(2) }} className="link solid">Let’s go</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              : null}
            {sliderStatus === 2 ?
              <div className="g-walkthrough-screen2 gstep">
                {/* walkthrough wrapper start */}
                <div className="g-walkthrough-wrapper">
                  {/* walkthrough wrapper divided in two parts */}
                  <div className="g-walk-row">
                    {/* left part is containing gif image related to walkthrough step. */}
                    <div className="g-walk-col-left"><img src={require("../../assets/img/assessment-walkthrough/asmt-step2.gif").default} alt="Question Walkthrough" className="close-img" /></div>
                    {/* right part has heading, text and buttons navigate from one to next, next to previous and close. */}
                    <div className="g-walk-col-right">
                      <div className="col-right-card-wrap">
                        <div className="card-header">
                          <div className="left-text-wrap">
                            <p>2 of 4</p>
                          </div>
                          <div className="close-btn">
                            <button className="close" onClick={handleClose}><img src={require("../../assets/img/chapter-walkimg/close-gray.svg").default} alt="digital_maturity" /></button>
                          </div>
                        </div>
                        <div className="card-body">
                          <h4 className="heading">Assessment Basics</h4>
                          {/*comment2*/}
                          <p className="txt">This is the Assessment's main interface.​</p>
                          <p className="txt">Track the overall and each section's progress. Use the top navigation to move around.</p>
                        </div>
                        <div className="card-footer">
                          <div className="card-footer-section">
                            <div className="card-footer-left">
                              <button className="circle" onClick={() => { HandleSlider(1) }} disabled={sliderStatus === 1 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(2) }} disabled={sliderStatus === 2 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(3) }} disabled={sliderStatus === 3 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(4) }} disabled={sliderStatus === 4 ? true : false}></button>
                            </div>
                            <div className="card-footer-right">
                              <button onClick={() => { HandleSlider(1) }} className="prev-link link">Previous</button>
                              <button onClick={() =>{ HandleSlider(3) }} className="let link solid">Next</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              : null}
              {sliderStatus === 3 ?
              <div className="g-walkthrough-screen3 gstep">
                {/* walkthrough wrapper start */}
                <div className="g-walkthrough-wrapper">
                  {/* walkthrough wrapper divided in two parts */}
                  <div className="g-walk-row">
                     {/* left part is containing gif image related to walkthrough step. */}
                    <div className="g-walk-col-left"><img src={require("../../assets/img/assessment-walkthrough/asmt-step3.gif").default} alt="Question Walkthrough" className="close-img" /></div>
                    {/* right part has heading, text and buttons navigate from one to next, next to previous and close. */}
                    <div className="g-walk-col-right">
                      <div className="col-right-card-wrap">
                        <div className="card-header">
                          <div className="left-text-wrap">
                            <p>3 of 4</p>
                          </div>
                          <div className="close-btn">
                            <button className="close" onClick={handleClose}><img src={require("../../assets/img/chapter-walkimg/close-gray.svg").default} alt="digital_maturity" /></button>
                          </div>
                        </div>
                        <div className="card-body">
                          <h4 className="heading">Assessment Collaboration</h4>
                          {/*comment2*/}
                          <p className="txt">Learn more information about each section.</p>
                          <p className="txt">See who is responsible to complete the section.</p>
                        </div>
                        <div className="card-footer">
                          <div className="card-footer-section">
                            <div className="card-footer-left">
                              <button className="circle" onClick={() => { HandleSlider(1) }} disabled={sliderStatus === 1 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(2) }} disabled={sliderStatus === 2 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(3) }} disabled={sliderStatus === 3 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(4) }} disabled={sliderStatus === 4 ? true : false}></button>
                            </div>
                            <div className="card-footer-right">
                              <button onClick={() => { HandleSlider(2) }} className="prev-link link">Previous</button>
                              <button onClick={() =>{ HandleSlider(4) }} className="let link solid">Next</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              : null}
            {sliderStatus === 4 ?
              <div className="g-walkthrough-screen3 gstep">
                 {/* walkthrough wrapper start */}
                <div className="g-walkthrough-wrapper">
                  {/* walkthrough wrapper divided in two parts */}
                  <div className="g-walk-row">
                    {/* left part is containing gif image related to walkthrough step. */}
                    <div className="g-walk-col-left"><img src={require("../../assets/img/assessment-walkthrough/asmt-step4.gif").default} alt="Question Walkthrough" className="close-img" /></div>
                    {/* right part has heading, text and buttons navigate from one to next, next to previous and close. */}
                    <div className="g-walk-col-right">
                      <div className="col-right-card-wrap">
                        <div className="card-header">
                          <div className="left-text-wrap">
                            <p>4 of 4</p>
                          </div>
                          <div className="close-btn">
                            <button className="close" onClick={handleClose}><img src={require("../../assets/img/chapter-walkimg/close-gray.svg").default} alt="digital_maturity" /></button>
                          </div>
                        </div>
                        <div className="card-body">
                          <h4 className="heading">Select a Section</h4>
                          {/*comment2*/}
                          <p className="txt">Click on the arrow to access the section and view its chapters.</p>
                          <p className="txt">Navigate through and complete the questionnaire(s) you have been assigned to.</p>
                        </div>
                        <div className="card-footer">
                          <div className="card-footer-section">
                            <div className="card-footer-left">
                              <button className="circle" onClick={() => { HandleSlider(1) }} disabled={sliderStatus === 1 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(2) }} disabled={sliderStatus === 2 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(3) }} disabled={sliderStatus === 3 ? true : false}></button>
                              <button className="circle" onClick={() => { HandleSlider(4) }} disabled={sliderStatus === 4 ? true : false}></button>
                            </div>
                           <div className="card-footer-right">
                              <button onClick={() => { HandleSlider(1) }} className="prev-link link">Restart</button>
                              <button onClick={() => handleClose()} className="let link solid">Close</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              : null}
            </div>
        </div>
      </section>
      </>
      )}
    </>

    );
  };